export default __webpack_public_path__ + "static/media/PragudeCastle_sm.d13f9ef2.jpg";